"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.YandexMap = void 0;
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _reactYandexMaps = require("@pbe/react-yandex-maps");
var _react = require("react");
var _SearchConfigurationProvider = require("../../containers/SearchConfigurationProvider");
var _contexts = require("../../contexts");
var _models = require("../../models");
var _shared = require("../shared");
var _jsxRuntime = require("react/jsx-runtime");
const MapContainer = (0, _mui.styled)('div')(()=>({
        width: '100%',
        height: '100%'
    }));
const transformLatLng = (coordinates)=>{
    var _coordinates_, _coordinates_1;
    return {
        latitude: (_coordinates_ = coordinates[0]) !== null && _coordinates_ !== void 0 ? _coordinates_ : 0,
        longitude: (_coordinates_1 = coordinates[1]) !== null && _coordinates_1 !== void 0 ? _coordinates_1 : 0
    };
};
const YandexInner = ()=>{
    const { getTestIdProps } = (0, _testidGenerator.default)();
    const yMaps = (0, _reactYandexMaps.useYMaps)([
        'Map',
        'Placemark'
    ]);
    const map = (0, _react.useRef)();
    const mapContainer = (0, _react.useRef)(null);
    const { viewSettings, setMapMethods, setViewSettings } = (0, _SearchConfigurationProvider.useSearchConfiguration)();
    const { currentLocation, setSelectedDelivery } = (0, _contexts.useMap)();
    const { clusters } = (0, _contexts.usePickupPoints)();
    const updatePushpins = (0, _react.useCallback)(async ()=>{
        if (!viewSettings || !yMaps || !map.current) {
            return;
        }
        // Clean old pins
        map.current.geoObjects.removeAll();
        // Render clusters and points
        clusters.forEach((param)=>{
            let { isSelected, latitude, longitude, ...entry } = param;
            var _map_current;
            const placemark = new yMaps.Placemark([
                latitude,
                longitude
            ], {}, {
                iconImageHref: entry.type === 'point' ? (0, _shared.getPickupPointMapIconSvgString)(entry.deliveryMethod, isSelected, true) : (0, _shared.getClusterMapIconSvgString)(entry.displaySize, isSelected, true),
                iconLayout: 'default#image',
                iconImageSize: [
                    60,
                    60
                ]
            });
            placemark.events.add('click', entry.type === 'point' ? ()=>setSelectedDelivery(entry.deliveryChannelId, {
                    latitude,
                    longitude
                }, viewSettings.zoom) : ()=>{
                var _map_current;
                const padding = Math.round(_shared.baseMarkerSize / 2);
                void ((_map_current = map.current) === null || _map_current === void 0 ? void 0 : _map_current.setBounds([
                    [
                        entry.south,
                        entry.west
                    ],
                    [
                        entry.north,
                        entry.east
                    ]
                ], {
                    zoomMargin: [
                        padding,
                        padding
                    ]
                }));
            });
            (_map_current = map.current) === null || _map_current === void 0 ? void 0 : _map_current.geoObjects.add(placemark);
        });
        // Render current location pin
        if (currentLocation) {
            map.current.geoObjects.add(new yMaps.Placemark([
                currentLocation.latitude,
                currentLocation.longitude
            ], {}, {
                iconImageHref: (0, _shared.getCurrentLocationIconSvgString)(true),
                iconLayout: 'default#image',
                iconImageSize: [
                    60,
                    60
                ]
            }));
        }
    }, [
        clusters,
        currentLocation,
        setSelectedDelivery,
        viewSettings,
        yMaps
    ]);
    // Load map script
    (0, _react.useEffect)(()=>{
        if (!viewSettings || !yMaps || !mapContainer.current) {
            return;
        }
        if (!map.current) {
            const yandexMap = new yMaps.Map(mapContainer.current, {
                center: [
                    viewSettings.location.latitude,
                    viewSettings.location.longitude
                ],
                zoom: viewSettings.zoom
            });
            map.current = yandexMap;
            // Deselect last selection
            yandexMap.events.add('click', ()=>setSelectedDelivery());
            // Update map view settings
            yandexMap.events.add('boundschange', ()=>{
                const location = transformLatLng(yandexMap.getCenter());
                const zoom = yandexMap.getZoom();
                setViewSettings((p)=>zoom === p.zoom && location.latitude === p.location.latitude && location.longitude === p.location.longitude ? p : {
                        location,
                        zoom
                    });
            });
            // TODO: Remove map methods after flat selection UI is used in all markets
            const getViewSettings = (viewOptions)=>{
                var _viewOptions_location, _viewOptions_zoom;
                return {
                    location: (_viewOptions_location = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.location) !== null && _viewOptions_location !== void 0 ? _viewOptions_location : transformLatLng(yandexMap.getCenter()),
                    zoom: (_viewOptions_zoom = viewOptions === null || viewOptions === void 0 ? void 0 : viewOptions.zoom) !== null && _viewOptions_zoom !== void 0 ? _viewOptions_zoom : yandexMap.getZoom()
                };
            };
            // TODO: Remove map methods after flat selection UI is used in all markets
            // Expose the generic map methods
            setMapMethods({
                getViewSettings,
                setLocationOrZoom: (viewOptions)=>{
                    const { location, zoom } = getViewSettings(viewOptions);
                    void yandexMap.setCenter([
                        location.latitude,
                        location.longitude
                    ], zoom);
                    setViewSettings({
                        location,
                        zoom
                    });
                },
                getViewBounds: ()=>{
                    const [sw = [], ne = []] = yandexMap.getBounds();
                    const [north = 0, east = 0] = ne;
                    const [south = 0, west = 0] = sw;
                    return {
                        east,
                        north,
                        south,
                        west
                    };
                },
                setViewBounds: (param, padding)=>{
                    let { east, north, south, west } = param;
                    void yandexMap.setBounds([
                        [
                            south,
                            west
                        ],
                        [
                            north,
                            east
                        ]
                    ], {
                        zoomMargin: padding === undefined ? undefined : [
                            padding,
                            padding
                        ]
                    });
                }
            });
        }
        // Update map view to match view settings
        void map.current.setCenter([
            viewSettings.location.latitude,
            viewSettings.location.longitude
        ], viewSettings.zoom);
        void updatePushpins();
    }, [
        currentLocation,
        viewSettings,
        yMaps,
        setSelectedDelivery,
        updatePushpins,
        setMapMethods,
        setViewSettings
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(MapContainer, {
        ref: mapContainer,
        ...getTestIdProps(_models.TestId.YandexMapContainer)
    });
};
const YandexMap = ()=>{
    const { credentials } = (0, _SearchConfigurationProvider.useSearchConfiguration)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactYandexMaps.YMaps, {
        query: {
            apikey: credentials
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(YandexInner, {})
    });
};
exports.YandexMap = YandexMap;
var _default = exports.default = YandexMap;
